import { useState } from "react";
import { ConsoleShell, PageHead } from "../components/ConsoleShell.js";
import { Card } from "../components/Card.js";
import { Tag, Tabs, TabPanel, EmptyState, BtnLink } from "../components/index.js";
import { Icon } from "../components/Icon.js";

/**
 * テンプレート・部品（スタジオ）。
 *
 * 業種別ひな型 / 共通手順の参照部品 / ブランドキットを管理する将来画面。
 * これらを永続化・配信するAPI（routes/*）はまだ存在しないため、偽の一覧や数値は出さず、
 * 各タブを正直な「準備中」表示にする。タブ構造と外枠（ConsoleShell/PageHead）は維持し、
 * 実データのある /library（マニュアル一覧）への導線を添える。
 */
export function Studio() {
  const [tab, setTab] = useState("templates");
  return (
    <ConsoleShell breadcrumb={["TEBIKI", "テンプレ・部品"]}>
      <PageHead title={<>テンプレート<span className="hl">・部品</span></>}>
        業種別ひな型・共通手順の部品・ブランドキットを一元管理する場所。共通手順は元を更新すれば
        参照しているすべてのマニュアルへ反映する設計です。
      </PageHead>

      <Tabs
        active={tab}
        onChange={setTab}
        ariaLabel="スタジオビュー"
        tabs={[
          { id: "templates", label: "テンプレート" },
          { id: "parts", label: "共通手順の部品" },
          { id: "brand", label: "ブランドキット" },
        ]}
      />

      <TabPanel id="templates" active={tab}>
        <Card crop pad className="reveal">
          <div className="spread" style={{ marginBottom: 4 }}>
            <div className="kicker">TEMPLATES</div>
            <Tag>準備中</Tag>
          </div>
          <EmptyState
            icon={<Icon name="studio" size={30} />}
            title="業種別テンプレートは準備中です"
            action={<BtnLink to="/library" variant="ghost">ライブラリを見る</BtnLink>}
          >
            開店・閉店、清掃、安全対応などの業種別ひな型から新しいマニュアルを起こせるようにします。
            まずは撮影してできたマニュアルをライブラリで確認できます。
          </EmptyState>
        </Card>
      </TabPanel>

      <TabPanel id="parts" active={tab}>
        <Card crop pad className="reveal d1">
          <div className="spread" style={{ marginBottom: 4 }}>
            <div className="kicker">SHARED STEPS</div>
            <Tag>準備中</Tag>
          </div>
          <EmptyState
            icon={<Icon name="versions" size={30} />}
            title="共通手順の部品は準備中です"
          >
            手洗いや消毒液の希釈といった共通手順を「参照型の部品」として一度だけ作り、複数のマニュアルで
            使い回せるようにします。元の部品を更新すると、参照しているすべてのマニュアルへ自動で反映されます。
          </EmptyState>
        </Card>
      </TabPanel>

      <TabPanel id="brand" active={tab}>
        <Card crop pad className="reveal d2">
          <div className="spread" style={{ marginBottom: 4 }}>
            <div className="kicker">BRAND KIT</div>
            <Tag>準備中</Tag>
          </div>
          <EmptyState
            icon={<Icon name="brand-kit" size={30} />}
            title="ブランドキットは準備中です"
          >
            ロゴ・配色・書体・透かしを設定し、全マニュアルの表紙とPDF出力へ一括で適用できるようにします。
          </EmptyState>
        </Card>
      </TabPanel>
    </ConsoleShell>
  );
}
